import { atomWithReset as stateSegmentWithReset } from 'jotai/utils';

export const contentPaginationStateSegment = stateSegmentWithReset(-1);
contentPaginationStateSegment.debugLabel = 'contentPaginationStateSegment';
